export function containsHtmlTag(text) {
  return /<[a-z/][\s\S]*>/i.test(text);
}
